import React from 'react';
import { App, Button } from '@myua/kit';
import { Trash } from '@myua/icons/dist/bulk16';
import { Asset, AssetPerm } from '../../../api';
import { useRemover } from '../useRemover';

export const DeleteAssetButton: React.FC<{ asset: Pick<Asset, 'id' | 'name'> }> = ({ asset }) => {
  const { modal } = App.useApp();
  const { remove, inProgress } = useRemover();

  return (
    <Button
      danger
      title="Delete asset file from storage. This action cannot be undone."
      icon={<Trash />}
      loading={inProgress}
      onClick={() => {
        modal.confirm({
          title: 'Confirm deletion',
          content: `Are you sure you want to delete "${asset.name}"? This action cannot be undone.`,
          okText: 'Delete',
          okButtonProps: { danger: true },
          icon: null,
          onOk: async (close) => {
            const ok = await remove(asset.id);
            if (ok) close();
          },
        });
      }}
    ></Button>
  );
};

export const DeleteAssetButtonMultiple: React.FC<{ assets: Asset[] }> = ({ assets }) => {
  const { modal } = App.useApp();
  const { removeMany, inProgress } = useRemover();

  const deletable = assets.filter((a) => a.perms.includes(AssetPerm.delete));
  if (deletable.length === 0) return null;

  return (
    <Button
      danger
      icon={<Trash />}
      loading={inProgress}
      onClick={() => {
        const count = deletable.length;
        modal.confirm({
          title: 'Confirm deletion',
          content: `Are you sure you want to delete ${count} ${
            count === 1 ? 'file' : 'files'
          }? This action cannot be undone.`,
          okText: 'Delete',
          okButtonProps: { danger: true },
          icon: null,
          onOk: async (close) => {
            const ok = await removeMany(deletable.map((a) => a.id));
            if (ok) close();
          },
        });
      }}
    >
      Delete
    </Button>
  );
};
